import { render, staticRenderFns } from "./FraudDetails.vue?vue&type=template&id=3057f6ca&scoped=true"
import script from "./FraudDetails.vue?vue&type=script&lang=js"
export * from "./FraudDetails.vue?vue&type=script&lang=js"
import style0 from "./FraudDetails.vue?vue&type=style&index=0&id=3057f6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057f6ca",
  null
  
)

export default component.exports